import { observer } from 'mobx-react-lite'
import { ServiceItemListDialog } from '@/features/jobs/details/components/ServiceItemListDialog'
import { type ServiceItemListDialogViewModel } from './ServiceItemListDialogViewModel'

export interface ServiceItemListDialogContainerProps {
  vm: ServiceItemListDialogViewModel
}

export const ServiceItemListDialogContainer = observer(
  function ServiceItemListDialogContainer({
    vm,
  }: ServiceItemListDialogContainerProps) {
    return (
      <ServiceItemListDialog
        showing={vm.modal.showing}
        serviceItems={vm.serviceItems}
        canSeePriceAsAdmin={vm.canSeePriceAsAdmin}
        canSeeProPayoutAsAdmin={vm.canSeeProPayoutAsAdmin}
        onClose={vm.modal.close}
      />
    )
  },
)
